import React, { useEffect } from "react";
import Analytics from "../../components/analytics-component/analytics.js";
import useTitle from "../../hooks/useTitle.js";
import { isLoggedIn } from "../../utils/auth.js";

export default function AnalyticsPage({ setPageTitle }) {
  useTitle("Analytics");

  useEffect(() => {
    setPageTitle("Analytics");
  });

  if (!isLoggedIn()) {
    window.location = "/";
    return null;
  }

  return <Analytics />;
}
